module.exports = __webpack_public_path__ + "media/landing_page/city-page-hero-desktop-3add7dd5.jpg";